import { Button } from './Button'

export const ButtonA = Button.withComponent('a')
